import { makeStyles } from "@material-ui/core/styles"

const useStyles = makeStyles(theme => ({
  label: {
    display: "flex",
    justifyContent: "space-between",
    height: "30px",
    width: "180px",
    fontSize: "13px",
    textTransform: "none",
    padding: "8x 8px 0 8px",
    borderBottom: "1px solid #EFEFEF",
    alignItems: "center",
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },
  },
  tabFlexContainer: {
    [theme.breakpoints.down("xs")]: {
      justifyContent: "space-between",
    },
  },
}))

export default useStyles
